import client from '../client';
import type { ApiResponse } from '../../types/api';

export type DevicePlatform = 'ios' | 'android' | 'web';

export interface RegisterDevicePayload {
  token: string;
  platform: DevicePlatform;
  bundleId?: string;
  environment?: 'production' | 'sandbox';
  appVersion?: string;
  locale?: string;
  storeIds?: string[];
}

export const devicesApi = {
  register: async (payload: RegisterDevicePayload): Promise<void> => {
    await client.post<ApiResponse<{ registered: boolean }>>(
      '/dashboard/devices',
      payload,
    );
  },
  unregister: async (token: string): Promise<void> => {
    await client.delete<ApiResponse<{ unregistered: boolean }>>(
      `/dashboard/devices/${encodeURIComponent(token)}`,
    );
  },
};
